import { render, staticRenderFns } from "./ExercicioFiscalList.vue?vue&type=template&id=3296a9e3"
import script from "./ExercicioFiscalList.vue?vue&type=script&lang=js"
export * from "./ExercicioFiscalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports